import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';

/* Components */
import ConversionFlowModal from './ConversionFlowModal';

/* Images */
import placeholder from '~/../img/vehicle-placeholder.png';

import { getBanner } from '../helpers';
import ConversionFlowForm from "./ConversionFlowForm";

export default function ConversionFlow({ flowUrl, triggerSelector, triggerEvent = 'click', datalayerData, summaryMinimal = false, suluImage = false, flowDisclaimer, conversionUsps, klantenvertellenScore, isVdp = false }) {
    const { ...form } = useForm({ shouldUnregister: true });
    const [open, setOpen] = useState(false);
    const [params, setParams] = useState({});

    const handleTrigger = (e) => {
        e.preventDefault();
        setParams(JSON.parse(e.currentTarget?.dataset?.flowQueryParams || '{}'));
        setOpen(true);
    }

    const handleClose = () => {
        setParams({});
        setOpen(false);
    }

    const storeUnfinishedFlow = (flow) => {
        if (flow.id && flow.id !== '') {
            const activeStep = flow?.steps.find((step) => step.active);
            if (activeStep?.last) return;

            const currentTime = new Date().getTime();
            const timestamp7DaysLater = currentTime + 7 * 24 * 60 * 60 * 1000;

            localStorage.setItem('unfinished-flow', JSON.stringify({
                id: flow.id,
                vehicleId: flow.summary?.vehicle?.vehicle_id,
                image: flow.summary?.vehicle?.image,
                brand: flow.summary?.vehicle?.brand,
                model: flow.summary?.vehicle?.model,
                type: flow.summary?.vehicle?.type,
                url: flow.referer,
                flowType: flow.flowName,
                flowId: flow.flowId,
                flowTitle: flow.flowTitle,
                timestamp: timestamp7DaysLater
            }));
        }
    }

    useEffect(() => {
        const triggerElements = Array.from(document.querySelectorAll(triggerSelector));

        triggerElements.forEach((triggerElement) => {
            triggerElement.addEventListener(triggerEvent, handleTrigger);
        });

        const url = new URL(window.location.href);
        const openLastFlow = url.searchParams.has('openLastFlow');
        const hasOpenModal = document.querySelector('.modal.show');

        if (isVdp && openLastFlow && !hasOpenModal) checkUnfinishedFlow();

        return () => {
            triggerElements.forEach((triggerElement) => {
                triggerElement.removeEventListener(triggerEvent, handleTrigger);
            });
        }
    }, []);

    const checkUnfinishedFlow = () => {
        const unfinishedFlow = localStorage.getItem('unfinished-flow');
        const vehicleId = flowRequestParams.get('vehicle_id');
        const baseFlowUrl = flowUrl.split('?')[0];

        if (unfinishedFlow && vehicleId && !open) {
            const flowObject = JSON.parse(unfinishedFlow);

            if ((!baseFlowUrl.includes(flowObject.flowType) && !baseFlowUrl.includes(flowObject.flowId)) || (vehicleId !== flowObject.vehicleId.toString())) return;

            setParams({
                vehicle_id: flowObject.vehicleId,
                uuid: flowObject.id
            });

            setOpen(true);
        }
    }

    const flowRequestUrl = new URL(flowUrl, window.location.origin);
    const flowRequestParams = flowRequestUrl?.searchParams;

    Object.entries(params || {}).forEach(([key, value]) => {
        flowRequestParams.set(key.toString(), value.toString());
    });

    flowRequestUrl.search = flowRequestParams;

    return (
        <ConversionFlowModal
            open={open}
            handleClose={handleClose}
            flowUrl={flowRequestUrl.toString()}
            modalBody={(passProps) => {

                const { flow } = passProps;
                const { doRequest } = passProps;
                const { setStep } = passProps;

                const Banner = getBanner(flow?.flowName);
                const image = flow?.summary?.vehicle?.image ? flow?.summary?.vehicle?.image : `${window.location.origin}${placeholder}`;
                const vehicleImage = suluImage ? window.location.host + image : image;
                const activeStep = flow?.steps.find((step) => step.active);

                if (flow) storeUnfinishedFlow(flow);

                if (activeStep?.last) {
                    localStorage.removeItem('unfinished-flow');
                }

                return (
                    <>
                        <ConversionFlowForm
                            {...passProps}
                            flow={flow}
                            form={form}
                            doRequest={doRequest}
                            handleClose={handleClose}
                            Banner={Banner}
                            vehicleImage={vehicleImage}
                            activeStep={activeStep}
                            datalayerData={datalayerData}
                            setStep={setStep}
                            flowDisclaimer={flowDisclaimer}
                            conversionUsps={conversionUsps}
                            klantenvertellenScore={klantenvertellenScore}
                            summaryMinimal={summaryMinimal}
                        />
                    </>
                )
            }}
        />
    )
}
